import { kebabCase } from 'es-toolkit/compat';
import { IntlShape } from 'react-intl';

export const getAmenitiesLabel = (intl: IntlShape, amenity: string) => {
  const kebabAmenity = kebabCase(amenity);
  const key = `amenities/${kebabAmenity}`;

  switch (key) {
    case 'amenities/audio-visual-equipment-rental':
      return intl.formatMessage({
        id: 'amenities/audio-visual-equipment-rental',
        defaultMessage: 'Audio / Visual equipment rental',
      });
    case 'amenities/atm-on-site':
      return intl.formatMessage({
        id: 'amenities/atm-on-site',
        defaultMessage: 'ATM on site',
      });
    case 'amenities/baggage-storage':
      return intl.formatMessage({
        id: 'amenities/baggage-storage',
        defaultMessage: 'Baggage storage',
      });
    case 'amenities/concierge':
      return intl.formatMessage({
        id: 'amenities/concierge',
        defaultMessage: 'Concierge',
      });
    case 'amenities/elevator':
      return intl.formatMessage({
        id: 'amenities/elevator',
        defaultMessage: 'Elevator',
      });
    case 'amenities/fax-services':
      return intl.formatMessage({
        id: 'amenities/fax-services',
        defaultMessage: 'Fax services',
      });
    case 'amenities/fitness-center':
      return intl.formatMessage({
        id: 'amenities/fitness-center',
        defaultMessage: 'Fitness center',
      });
    case 'amenities/foreign-currency-exchange':
      return intl.formatMessage({
        id: 'amenities/foreign-currency-exchange',
        defaultMessage: 'Foreign currency exchange',
      });
    case 'amenities/gift-shop':
      return intl.formatMessage({
        id: 'amenities/gift-shop',
        defaultMessage: 'Gift shop',
      });
    case 'amenities/high-chairs':
      return intl.formatMessage({
        id: 'amenities/high-chairs',
        defaultMessage: 'High chairs',
      });
    case 'amenities/laundry-service':
      return intl.formatMessage({
        id: 'amenities/laundry-service',
        defaultMessage: 'Laundry service',
      });
    case 'amenities/lounge':
      return intl.formatMessage({
        id: 'amenities/lounge',
        defaultMessage: 'Lounge',
      });
    case 'amenities/luggage-hold':
      return intl.formatMessage({
        id: 'amenities/luggage-hold',
        defaultMessage: 'Luggage hold',
      });
    case 'amenities/meeting-rooms':
      return intl.formatMessage({
        id: 'amenities/meeting-rooms',
        defaultMessage: 'Meeting rooms',
      });
    case 'amenities/photocopying-services':
      return intl.formatMessage({
        id: 'amenities/photocopying-services',
        defaultMessage: 'Photocopying services',
      });
    case 'amenities/printer':
      return intl.formatMessage({
        id: 'amenities/printer',
        defaultMessage: 'Printer',
      });
    case 'amenities/room-service':
      return intl.formatMessage({
        id: 'amenities/room-service',
        defaultMessage: 'Room service',
      });
    case 'amenities/safe-deposit-boxes-at-front-desk':
      return intl.formatMessage({
        id: 'amenities/safe-deposit-boxes-at-front-desk',
        defaultMessage: 'Safe deposit boxes at front desk',
      });
    case 'amenities/shoeshine':
      return intl.formatMessage({
        id: 'amenities/shoeshine',
        defaultMessage: 'Shoeshine',
      });
    case 'amenities/swimming-pool':
      return intl.formatMessage({
        id: 'amenities/swimming-pool',
        defaultMessage: 'Swimming pool',
      });
    case 'amenities/valet-service':
      return intl.formatMessage({
        id: 'amenities/valet-service',
        defaultMessage: 'Valet service',
      });
    case 'amenities/24-hour-check-in':
      return intl.formatMessage({
        id: 'amenities/24-hour-check-in',
        defaultMessage: '24-hour check-in',
      });
    case 'amenities/24-hour-front-desk':
      return intl.formatMessage({
        id: 'amenities/24-hour-front-desk',
        defaultMessage: '24-hour front desk',
      });
    case 'amenities/24-hour-security':
      return intl.formatMessage({
        id: 'amenities/24-hour-security',
        defaultMessage: '24-hour security',
      });
    case 'amenities/access-to-healthcare-professionals':
      return intl.formatMessage({
        id: 'amenities/access-to-healthcare-professionals',
        defaultMessage: 'Access to healthcare professionals',
      });
    case 'amenities/accessible-parking':
      return intl.formatMessage({
        id: 'amenities/accessible-parking',
        defaultMessage: 'Accessible Parking',
      });
    case 'amenities/aerobics':
      return intl.formatMessage({
        id: 'amenities/aerobics',
        defaultMessage: 'Aerobics',
      });
    case 'amenities/air-conditioning':
      return intl.formatMessage({
        id: 'amenities/air-conditioning',
        defaultMessage: 'Air conditioning',
      });
    case 'amenities/airport-shuttle':
      return intl.formatMessage({
        id: 'amenities/airport-shuttle',
        defaultMessage: 'Airport shuttle',
      });
    case 'amenities/all-rooms-disinfected-daily':
      return intl.formatMessage({
        id: 'amenities/all-rooms-disinfected-daily',
        defaultMessage: 'All rooms disinfected daily',
      });
    case 'amenities/all-inclusive-meals':
      return intl.formatMessage({
        id: 'amenities/all-inclusive-meals',
        defaultMessage: 'All-inclusive meals',
      });
    case 'amenities/archery':
      return intl.formatMessage({
        id: 'amenities/archery',
        defaultMessage: 'Archery',
      });
    case 'amenities/auditory-guidance':
      return intl.formatMessage({
        id: 'amenities/auditory-guidance',
        defaultMessage: 'Auditory guidance',
      });
    case 'amenities/baby-safety-gates':
      return intl.formatMessage({
        id: 'amenities/baby-safety-gates',
        defaultMessage: 'Baby safety gates',
      });
    case 'amenities/babysitting-child-services':
      return intl.formatMessage({
        id: 'amenities/babysitting-child-services',
        defaultMessage: 'Babysitting / Child services',
      });
    case 'amenities/badminton':
      return intl.formatMessage({
        id: 'amenities/badminton',
        defaultMessage: 'Badminton',
      });
    case 'amenities/banquet-rooms':
      return intl.formatMessage({
        id: 'amenities/banquet-rooms',
        defaultMessage: 'Banquet rooms',
      });
    case 'amenities/bar':
      return intl.formatMessage({
        id: 'amenities/bar',
        defaultMessage: 'Bar',
      });
    case 'amenities/bar-crawls':
      return intl.formatMessage({
        id: 'amenities/bar-crawls',
        defaultMessage: 'Bar crawls',
      });
    case 'amenities/bathhouse':
      return intl.formatMessage({
        id: 'amenities/bathhouse',
        defaultMessage: 'Bathhouse',
      });
    case 'amenities/bathroom-emergency-pull-cord':
      return intl.formatMessage({
        id: 'amenities/bathroom-emergency-pull-cord',
        defaultMessage: 'Bathroom emergency pull cord',
      });
    case 'amenities/bbq-facilities':
      return intl.formatMessage({
        id: 'amenities/bbq-facilities',
        defaultMessage: 'BBQ facilities',
      });
    case 'amenities/beach':
      return intl.formatMessage({
        id: 'amenities/beach',
        defaultMessage: 'Beach',
      });
    case 'amenities/beach-area-private':
      return intl.formatMessage({
        id: 'amenities/beach-area-private',
        defaultMessage: 'Beach area (private)',
      });
    case 'amenities/beach-chairs-loungers':
      return intl.formatMessage({
        id: 'amenities/beach-chairs-loungers',
        defaultMessage: 'Beach chairs / loungers',
      });
    case 'amenities/beach-umbrellas':
      return intl.formatMessage({
        id: 'amenities/beach-umbrellas',
        defaultMessage: 'Beach umbrellas',
      });
    case 'amenities/beachfront':
      return intl.formatMessage({
        id: 'amenities/beachfront',
        defaultMessage: 'Beachfront',
      });
    case 'amenities/beauty-services':
      return intl.formatMessage({
        id: 'amenities/beauty-services',
        defaultMessage: 'Beauty services',
      });
    case 'amenities/bicycle-rental':
      return intl.formatMessage({
        id: 'amenities/bicycle-rental',
        defaultMessage: 'Bicycle rental',
      });
    case 'amenities/bike-tours':
      return intl.formatMessage({
        id: 'amenities/bike-tours',
        defaultMessage: 'Bike tours',
      });
    case 'amenities/billiards-pool-table':
      return intl.formatMessage({
        id: 'amenities/billiards-pool-table',
        defaultMessage: 'Billiards / pool table',
      });
    case 'amenities/bingo':
      return intl.formatMessage({
        id: 'amenities/bingo',
        defaultMessage: 'Bingo',
      });
    case 'amenities/board-games-puzzles':
      return intl.formatMessage({
        id: 'amenities/board-games-puzzles',
        defaultMessage: 'Board games / puzzles',
      });
    case 'amenities/boating':
      return intl.formatMessage({
        id: 'amenities/boating',
        defaultMessage: 'Boating',
      });
    case 'amenities/body-thermometer':
      return intl.formatMessage({
        id: 'amenities/body-thermometer',
        defaultMessage: 'Body thermometer',
      });
    case 'amenities/books-dvds-music-for-kids':
      return intl.formatMessage({
        id: 'amenities/books-dvds-music-for-kids',
        defaultMessage: 'Books, DVDs, music for kids',
      });
    case 'amenities/bottled-water':
      return intl.formatMessage({
        id: 'amenities/bottled-water',
        defaultMessage: 'Bottled water',
      });
    case 'amenities/bowling':
      return intl.formatMessage({
        id: 'amenities/bowling',
        defaultMessage: 'Bowling',
      });
    case 'amenities/breakfast-buffet':
      return intl.formatMessage({
        id: 'amenities/breakfast-buffet',
        defaultMessage: 'Breakfast Buffet',
      });
    case 'amenities/breakfast-in-the-room':
      return intl.formatMessage({
        id: 'amenities/breakfast-in-the-room',
        defaultMessage: 'Breakfast in the room',
      });
    case 'amenities/breakfast-takeaway-containers':
      return intl.formatMessage({
        id: 'amenities/breakfast-takeaway-containers',
        defaultMessage: 'Breakfast takeaway containers',
      });
    case 'amenities/breakfast-continental':
      return intl.formatMessage({
        id: 'amenities/breakfast-continental',
        defaultMessage: 'Breakfast, Continental',
      });
    case 'amenities/breakfast-free':
      return intl.formatMessage({
        id: 'amenities/breakfast-free',
        defaultMessage: 'Breakfast, free',
      });
    case 'amenities/business-center':
      return intl.formatMessage({
        id: 'amenities/business-center',
        defaultMessage: 'Business center',
      });
    case 'amenities/buzzer-wireless-intercom':
      return intl.formatMessage({
        id: 'amenities/buzzer-wireless-intercom',
        defaultMessage: 'Buzzer / wireless intercom',
      });
    case 'amenities/canoeing':
      return intl.formatMessage({
        id: 'amenities/canoeing',
        defaultMessage: 'Canoeing',
      });
    case 'amenities/car-for-hire':
      return intl.formatMessage({
        id: 'amenities/car-for-hire',
        defaultMessage: 'Car for hire',
      });
    case 'amenities/car-rental':
      return intl.formatMessage({
        id: 'amenities/car-rental',
        defaultMessage: 'Car Rental',
      });
    case 'amenities/carbon-monoxide-detector':
      return intl.formatMessage({
        id: 'amenities/carbon-monoxide-detector',
        defaultMessage: 'Carbon monoxide detector',
      });
    case 'amenities/carbon-monoxide-sources':
      return intl.formatMessage({
        id: 'amenities/carbon-monoxide-sources',
        defaultMessage: 'Carbon monoxide sources',
      });
    case 'amenities/cashless-payment-accepted':
      return intl.formatMessage({
        id: 'amenities/cashless-payment-accepted',
        defaultMessage: 'Cashless payment accepted',
      });
    case 'amenities/casino':
      return intl.formatMessage({
        id: 'amenities/casino',
        defaultMessage: 'Casino',
      });
    case 'amenities/cctv-in-common-areas':
      return intl.formatMessage({
        id: 'amenities/cctv-in-common-areas',
        defaultMessage: 'CCTV in common areas',
      });
    case 'amenities/cctv-outside-property':
      return intl.formatMessage({
        id: 'amenities/cctv-outside-property',
        defaultMessage: 'CCTV outside property',
      });
    case 'amenities/chapel':
      return intl.formatMessage({
        id: 'amenities/chapel',
        defaultMessage: 'Chapel',
      });
    case 'amenities/chocolate-cookies':
      return intl.formatMessage({
        id: 'amenities/chocolate-cookies',
        defaultMessage: 'Chocolate / Cookies',
      });
    case 'amenities/cleaning-chemicals-used-are-effective-against-covid':
      return intl.formatMessage({
        id: 'amenities/cleaning-chemicals-used-are-effective-against-covid',
        defaultMessage: 'Cleaning chemicals used are effective agaist COVID',
      });
    case 'amenities/coffee-shop':
      return intl.formatMessage({
        id: 'amenities/coffee-shop',
        defaultMessage: 'Coffee Shop',
      });
    case 'amenities/common-areas-disinfected-daily':
      return intl.formatMessage({
        id: 'amenities/common-areas-disinfected-daily',
        defaultMessage: 'Common areas disinfected daily',
      });
    case 'amenities/common-stationery-removed':
      return intl.formatMessage({
        id: 'amenities/common-stationery-removed',
        defaultMessage: 'Common stationery removed',
      });
    case 'amenities/contactless-check-in-check-out':
      return intl.formatMessage({
        id: 'amenities/contactless-check-in-check-out',
        defaultMessage: 'Contactless check-in / check-out',
      });
    case 'amenities/cooking-class':
      return intl.formatMessage({
        id: 'amenities/cooking-class',
        defaultMessage: 'Cooking class',
      });
    case 'amenities/couples-only':
      return intl.formatMessage({
        id: 'amenities/couples-only',
        defaultMessage: 'Couples only',
      });
    case 'amenities/cycling':
      return intl.formatMessage({
        id: 'amenities/cycling',
        defaultMessage: 'Cycling',
      });
    case 'amenities/daily-housekeeping':
      return intl.formatMessage({
        id: 'amenities/daily-housekeeping',
        defaultMessage: 'Daily Housekeeping',
      });
    case 'amenities/darts':
      return intl.formatMessage({
        id: 'amenities/darts',
        defaultMessage: 'Darts',
      });
    case 'amenities/delivered-food-covered-securely':
      return intl.formatMessage({
        id: 'amenities/delivered-food-covered-securely',
        defaultMessage: 'Delivered food covered securely',
      });
    case 'amenities/designated-smoking-area':
      return intl.formatMessage({
        id: 'amenities/designated-smoking-area',
        defaultMessage: 'Designated smoking area',
      });
    case 'amenities/diving':
      return intl.formatMessage({
        id: 'amenities/diving',
        defaultMessage: 'Diving',
      });
    case 'amenities/doorman':
      return intl.formatMessage({
        id: 'amenities/doorman',
        defaultMessage: 'Doorman',
      });
    case 'amenities/dry-cleaning':
      return intl.formatMessage({
        id: 'amenities/dry-cleaning',
        defaultMessage: 'Dry Cleaning',
      });
    case 'amenities/electric-vehicle-charging-station':
      return intl.formatMessage({
        id: 'amenities/electric-vehicle-charging-station',
        defaultMessage: 'Electric vehicle charging station',
      });
    case 'amenities/entertainment-staff':
      return intl.formatMessage({
        id: 'amenities/entertainment-staff',
        defaultMessage: 'Entertainment staff',
      });
    case 'amenities/evening-entertainment':
      return intl.formatMessage({
        id: 'amenities/evening-entertainment',
        defaultMessage: 'Evening entertainment',
      });
    case 'amenities/express-check-in-check-out':
      return intl.formatMessage({
        id: 'amenities/express-check-in-check-out',
        defaultMessage: 'Express check-in / check-out',
      });
    case 'amenities/exterior-corridor':
      return intl.formatMessage({
        id: 'amenities/exterior-corridor',
        defaultMessage: 'Exterior corridor',
      });
    case 'amenities/face-masks-available-for-guests':
      return intl.formatMessage({
        id: 'amenities/face-masks-available-for-guests',
        defaultMessage: 'Face masks available for guests',
      });
    case 'amenities/face-masks-on-staff':
      return intl.formatMessage({
        id: 'amenities/face-masks-on-staff',
        defaultMessage: 'Face masks on staff',
      });
    case 'amenities/facilities-for-disabled-guests':
      return intl.formatMessage({
        id: 'amenities/facilities-for-disabled-guests',
        defaultMessage: 'Facilities for disabled guests',
      });
    case 'amenities/family-rooms':
      return intl.formatMessage({
        id: 'amenities/family-rooms',
        defaultMessage: 'Family rooms',
      });
    case 'amenities/fire-extinguishers':
      return intl.formatMessage({
        id: 'amenities/fire-extinguishers',
        defaultMessage: 'Fire extinguishers',
      });
    case 'amenities/fireplace':
      return intl.formatMessage({
        id: 'amenities/fireplace',
        defaultMessage: 'Fireplace',
      });
    case 'amenities/fireplace-outdoor':
      return intl.formatMessage({
        id: 'amenities/fireplace-outdoor',
        defaultMessage: 'Fireplace, outdoor',
      });
    case 'amenities/first-aid-kits':
      return intl.formatMessage({
        id: 'amenities/first-aid-kits',
        defaultMessage: 'First aid kits',
      });
    case 'amenities/fishing':
      return intl.formatMessage({
        id: 'amenities/fishing',
        defaultMessage: 'Fishing',
      });
    case 'amenities/food-can-be-delivered-for-in-room-dining':
      return intl.formatMessage({
        id: 'amenities/food-can-be-delivered-for-in-room-dining',
        defaultMessage: 'Food can be delivered for in-room dining',
      });
    case 'amenities/food-delivery':
      return intl.formatMessage({
        id: 'amenities/food-delivery',
        defaultMessage: 'Food delivery',
      });
    case 'amenities/foot-bath':
      return intl.formatMessage({
        id: 'amenities/foot-bath',
        defaultMessage: 'Foot bath',
      });
    case 'amenities/fruit':
      return intl.formatMessage({
        id: 'amenities/fruit',
        defaultMessage: 'Fruit',
      });
    case 'amenities/game-room':
      return intl.formatMessage({
        id: 'amenities/game-room',
        defaultMessage: 'Game room',
      });
    case 'amenities/garden':
      return intl.formatMessage({
        id: 'amenities/garden',
        defaultMessage: 'Garden',
      });
    case 'amenities/golf-course-on-site':
      return intl.formatMessage({
        id: 'amenities/golf-course-on-site',
        defaultMessage: 'Golf course on-site',
      });
    case 'amenities/golf-course-within-3-5-km-2-mi':
      return intl.formatMessage({
        id: 'amenities/golf-course-within-3-5-km-2-mi',
        defaultMessage: 'Golf course within 3.5 km / 2 mi',
      });
    case 'amenities/grocery-deliveries':
      return intl.formatMessage({
        id: 'amenities/grocery-deliveries',
        defaultMessage: 'Grocery deliveries',
      });
    case 'amenities/guest-accommodations-disinfected-between-stays':
      return intl.formatMessage({
        id: 'amenities/guest-accommodations-disinfected-between-stays',
        defaultMessage: 'Guest accommodations disinfected between stays',
      });
    case 'amenities/guest-accommodations-sealed-after-cleaning':
      return intl.formatMessage({
        id: 'amenities/guest-accommodations-sealed-after-cleaning',
        defaultMessage: 'Guest accommodations sealed after cleaning',
      });
    case 'amenities/guest-accommodation-cleaning-can-be-cancelled':
      return intl.formatMessage({
        id: 'amenities/guest-accommodation-cleaning-can-be-cancelled',
        defaultMessage: 'Guest accomodation cleaning can be cancelled',
      });
    case 'amenities/guest-health-checks':
      return intl.formatMessage({
        id: 'amenities/guest-health-checks',
        defaultMessage: 'Guest health checks',
      });
    case 'amenities/guest-parking':
      return intl.formatMessage({
        id: 'amenities/guest-parking',
        defaultMessage: 'Guest parking',
      });
    case 'amenities/guests-can-opt-out-of-daily-room-cleaning':
      return intl.formatMessage({
        id: 'amenities/guests-can-opt-out-of-daily-room-cleaning',
        defaultMessage: 'Guests can opt out of daily room cleaning',
      });
    case 'amenities/hair-beauty-salon':
      return intl.formatMessage({
        id: 'amenities/hair-beauty-salon',
        defaultMessage: 'Hair / Beauty salon',
      });
    case 'amenities/hand-sanitizer-provided':
      return intl.formatMessage({
        id: 'amenities/hand-sanitizer-provided',
        defaultMessage: 'Hand sanitizer provided',
      });
    case 'amenities/happy-hour':
      return intl.formatMessage({
        id: 'amenities/happy-hour',
        defaultMessage: 'Happy hour',
      });
    case 'amenities/heating':
      return intl.formatMessage({
        id: 'amenities/heating',
        defaultMessage: 'Heating',
      });
    case 'amenities/hiking':
      return intl.formatMessage({
        id: 'amenities/hiking',
        defaultMessage: 'Hiking',
      });
    case 'amenities/honeymoon-bridal-suite':
      return intl.formatMessage({
        id: 'amenities/honeymoon-bridal-suite',
        defaultMessage: 'Honeymoon / bridal suite',
      });
    case 'amenities/horseback-riding':
      return intl.formatMessage({
        id: 'amenities/horseback-riding',
        defaultMessage: 'Horseback riding',
      });
    case 'amenities/hot-spring-bath':
      return intl.formatMessage({
        id: 'amenities/hot-spring-bath',
        defaultMessage: 'Hot spring bath',
      });
    case 'amenities/hot-tub':
      return intl.formatMessage({
        id: 'amenities/hot-tub',
        defaultMessage: 'Hot Tub',
      });
    case 'amenities/hygiene-certification':
      return intl.formatMessage({
        id: 'amenities/hygiene-certification',
        defaultMessage: 'Hygiene certification',
      });
    case 'amenities/hypoallergenic-rooms':
      return intl.formatMessage({
        id: 'amenities/hypoallergenic-rooms',
        defaultMessage: 'Hypoallergenic rooms',
      });
    case 'amenities/indoor-play-area':
      return intl.formatMessage({
        id: 'amenities/indoor-play-area',
        defaultMessage: 'Indoor play area',
      });
    case 'amenities/infirmary':
      return intl.formatMessage({
        id: 'amenities/infirmary',
        defaultMessage: 'Infirmary',
      });
    case 'amenities/internet':
      return intl.formatMessage({
        id: 'amenities/internet',
        defaultMessage: 'Internet',
      });
    case 'amenities/invoices':
      return intl.formatMessage({
        id: 'amenities/invoices',
        defaultMessage: 'Invoices',
      });
    case 'amenities/ironing-service':
      return intl.formatMessage({
        id: 'amenities/ironing-service',
        defaultMessage: 'Ironing Service',
      });
    case 'amenities/karaoke':
      return intl.formatMessage({
        id: 'amenities/karaoke',
        defaultMessage: 'Karaoke',
      });
    case 'amenities/key-card-or-motion-controlled-electricity':
      return intl.formatMessage({
        id: 'amenities/key-card-or-motion-controlled-electricity',
        defaultMessage: 'Key card or motion-controlled electricity',
      });
    case 'amenities/kid-friendly-buffet':
      return intl.formatMessage({
        id: 'amenities/kid-friendly-buffet',
        defaultMessage: 'Kid-friendly buffet',
      });
    case 'amenities/kids-club':
      return intl.formatMessage({
        id: 'amenities/kids-club',
        defaultMessage: "Kids' club",
      });
    case 'amenities/kids-meals':
      return intl.formatMessage({
        id: 'amenities/kids-meals',
        defaultMessage: "Kids' meals",
      });
    case 'amenities/kids-tv-channels':
      return intl.formatMessage({
        id: 'amenities/kids-tv-channels',
        defaultMessage: "Kids' TV channels",
      });
    case 'amenities/library':
      return intl.formatMessage({
        id: 'amenities/library',
        defaultMessage: 'Library',
      });
    case 'amenities/linens-towels-laundry-washed-per-local-authority-guidelines':
      return intl.formatMessage({
        id: 'amenities/linens-towels-laundry-washed-per-local-authority-guidelines',
        defaultMessage:
          'Linens, towels, laundry washed per local authority guidelines',
      });
    case 'amenities/live-music-performance':
      return intl.formatMessage({
        id: 'amenities/live-music-performance',
        defaultMessage: 'Live music / performance',
      });
    case 'amenities/live-sports-events-broadcast':
      return intl.formatMessage({
        id: 'amenities/live-sports-events-broadcast',
        defaultMessage: 'Live sports events (broadcast)',
      });
    case 'amenities/local-safety-protocols-followed':
      return intl.formatMessage({
        id: 'amenities/local-safety-protocols-followed',
        defaultMessage: 'Local safety protocols followed',
      });
    case 'amenities/locker-rooms':
      return intl.formatMessage({
        id: 'amenities/locker-rooms',
        defaultMessage: 'Locker rooms',
      });
    case 'amenities/lockers':
      return intl.formatMessage({
        id: 'amenities/lockers',
        defaultMessage: 'Lockers',
      });
    case 'amenities/low-bathroom-sink':
      return intl.formatMessage({
        id: 'amenities/low-bathroom-sink',
        defaultMessage: 'Low bathroom sink',
      });
    case 'amenities/massage':
      return intl.formatMessage({
        id: 'amenities/massage',
        defaultMessage: 'Massage',
      });
    case 'amenities/massage-chair':
      return intl.formatMessage({
        id: 'amenities/massage-chair',
        defaultMessage: 'Massage chair',
      });
    case 'amenities/miniature-golf':
      return intl.formatMessage({
        id: 'amenities/miniature-golf',
        defaultMessage: 'Miniature golf',
      });
    case 'amenities/minimarket-convenience-store':
      return intl.formatMessage({
        id: 'amenities/minimarket-convenience-store',
        defaultMessage: 'Minimarket / Convenience store',
      });
    case 'amenities/mobile-app-for-room-service':
      return intl.formatMessage({
        id: 'amenities/mobile-app-for-room-service',
        defaultMessage: 'Mobile app for room service',
      });
    case 'amenities/movie-nights':
      return intl.formatMessage({
        id: 'amenities/movie-nights',
        defaultMessage: 'Movie nights',
      });
    case 'amenities/newspapers':
      return intl.formatMessage({
        id: 'amenities/newspapers',
        defaultMessage: 'Newspapers',
      });
    case 'amenities/nightclub-dj':
      return intl.formatMessage({
        id: 'amenities/nightclub-dj',
        defaultMessage: 'Nightclub / DJ',
      });
    case 'amenities/no-children-allowed':
      return intl.formatMessage({
        id: 'amenities/no-children-allowed',
        defaultMessage: 'No Children Allowed',
      });
    case 'amenities/non-smoking-rooms':
      return intl.formatMessage({
        id: 'amenities/non-smoking-rooms',
        defaultMessage: 'Non-smoking rooms',
      });
    case 'amenities/open-air-bath':
      return intl.formatMessage({
        id: 'amenities/open-air-bath',
        defaultMessage: 'Open-air bath',
      });
    case 'amenities/outdoor-furniture':
      return intl.formatMessage({
        id: 'amenities/outdoor-furniture',
        defaultMessage: 'Outdoor furniture',
      });
    case 'amenities/outdoor-play-equipment':
      return intl.formatMessage({
        id: 'amenities/outdoor-play-equipment',
        defaultMessage: 'Outdoor play equipment',
      });
    case 'amenities/personal-trainer':
      return intl.formatMessage({
        id: 'amenities/personal-trainer',
        defaultMessage: 'Personal trainer',
      });
    case 'amenities/physical-distancing-in-dining-areas':
      return intl.formatMessage({
        id: 'amenities/physical-distancing-in-dining-areas',
        defaultMessage: 'Physical distancing in dining areas',
      });
    case 'amenities/physical-distancing-rules':
      return intl.formatMessage({
        id: 'amenities/physical-distancing-rules',
        defaultMessage: 'Physical distancing rules',
      });
    case 'amenities/picnic-area':
      return intl.formatMessage({
        id: 'amenities/picnic-area',
        defaultMessage: 'Picnic area',
      });
    case 'amenities/playground':
      return intl.formatMessage({
        id: 'amenities/playground',
        defaultMessage: 'Playground',
      });
    case 'amenities/pool-beach-towels':
      return intl.formatMessage({
        id: 'amenities/pool-beach-towels',
        defaultMessage: 'Pool / Beach towels',
      });
    case 'amenities/portable-wi-fi-device-rental':
      return intl.formatMessage({
        id: 'amenities/portable-wi-fi-device-rental',
        defaultMessage: 'Portable wi-fi device rental',
      });
    case 'amenities/postal-service':
      return intl.formatMessage({
        id: 'amenities/postal-service',
        defaultMessage: 'Postal Service',
      });
    case 'amenities/prepared-lunches':
      return intl.formatMessage({
        id: 'amenities/prepared-lunches',
        defaultMessage: 'Prepared lunches',
      });
    case 'amenities/private-check-in-check-out':
      return intl.formatMessage({
        id: 'amenities/private-check-in-check-out',
        defaultMessage: 'Private check-in / check-out',
      });
    case 'amenities/property-cleaned-by-professional-cleaning-companies':
      return intl.formatMessage({
        id: 'amenities/property-cleaned-by-professional-cleaning-companies',
        defaultMessage: 'Property cleaned by professional cleaning companies',
      });
    case 'amenities/property-has-wheelchair-access':
      return intl.formatMessage({
        id: 'amenities/property-has-wheelchair-access',
        defaultMessage: 'Property has wheelchair access',
      });
    case 'amenities/public-transit-tickets':
      return intl.formatMessage({
        id: 'amenities/public-transit-tickets',
        defaultMessage: 'Public transit tickets',
      });
    case 'amenities/racquetball-squash':
      return intl.formatMessage({
        id: 'amenities/racquetball-squash',
        defaultMessage: 'Racquetball / Squash',
      });
    case 'amenities/raised-toilet':
      return intl.formatMessage({
        id: 'amenities/raised-toilet',
        defaultMessage: 'Raised toilet',
      });
    case 'amenities/refillable-water-stations':
      return intl.formatMessage({
        id: 'amenities/refillable-water-stations',
        defaultMessage: 'Refillable water stations',
      });
    case 'amenities/restaurant':
      return intl.formatMessage({
        id: 'amenities/restaurant',
        defaultMessage: 'Restaurant',
      });
    case 'amenities/restaurant-halal':
      return intl.formatMessage({
        id: 'amenities/restaurant-halal',
        defaultMessage: 'Restaurant (Halal)',
      });
    case 'amenities/restaurant-kosher':
      return intl.formatMessage({
        id: 'amenities/restaurant-kosher',
        defaultMessage: 'Restaurant (Kosher)',
      });
    case 'amenities/room-service-24-hours':
      return intl.formatMessage({
        id: 'amenities/room-service-24-hours',
        defaultMessage: 'Room service (24 hours)',
      });
    case 'amenities/safety-deposit-box':
      return intl.formatMessage({
        id: 'amenities/safety-deposit-box',
        defaultMessage: 'Safety deposit box',
      });
    case 'amenities/sanitized-tableware':
      return intl.formatMessage({
        id: 'amenities/sanitized-tableware',
        defaultMessage: 'Sanitized tableware',
      });
    case 'amenities/sauna':
      return intl.formatMessage({
        id: 'amenities/sauna',
        defaultMessage: 'Sauna',
      });
    case 'amenities/screens-between-staff-guests-where-needed':
      return intl.formatMessage({
        id: 'amenities/screens-between-staff-guests-where-needed',
        defaultMessage: 'Screens between staff / guests where needed',
      });
    case 'amenities/security-alarm':
      return intl.formatMessage({
        id: 'amenities/security-alarm',
        defaultMessage: 'Security alarm',
      });
    case 'amenities/self-service-laundry':
      return intl.formatMessage({
        id: 'amenities/self-service-laundry',
        defaultMessage: 'Self-service laundry',
      });
    case 'amenities/shared-kitchen':
      return intl.formatMessage({
        id: 'amenities/shared-kitchen',
        defaultMessage: 'Shared kitchen',
      });
    case 'amenities/shared-lounge-tv-area':
      return intl.formatMessage({
        id: 'amenities/shared-lounge-tv-area',
        defaultMessage: 'Shared lounge / TV area',
      });
    case 'amenities/shops-on-site':
      return intl.formatMessage({
        id: 'amenities/shops-on-site',
        defaultMessage: 'Shops (on site)',
      });
    case 'amenities/shrine':
      return intl.formatMessage({
        id: 'amenities/shrine',
        defaultMessage: 'Shrine',
      });
    case 'amenities/shuttle-service':
      return intl.formatMessage({
        id: 'amenities/shuttle-service',
        defaultMessage: 'Shuttle service',
      });
    case 'amenities/single-use-plastics-removed':
      return intl.formatMessage({
        id: 'amenities/single-use-plastics-removed',
        defaultMessage: 'Single-use plastics removed',
      });
    case 'amenities/ski-equipment-rental':
      return intl.formatMessage({
        id: 'amenities/ski-equipment-rental',
        defaultMessage: 'Ski equipment rental',
      });
    case 'amenities/ski-school':
      return intl.formatMessage({
        id: 'amenities/ski-school',
        defaultMessage: 'Ski school',
      });
    case 'amenities/skiing':
      return intl.formatMessage({
        id: 'amenities/skiing',
        defaultMessage: 'Skiing',
      });
    case 'amenities/smoke-alarms':
      return intl.formatMessage({
        id: 'amenities/smoke-alarms',
        defaultMessage: 'Smoke alarms',
      });
    case 'amenities/smoke-free-property':
      return intl.formatMessage({
        id: 'amenities/smoke-free-property',
        defaultMessage: 'Smoke-free property',
      });
    case 'amenities/snack-bar':
      return intl.formatMessage({
        id: 'amenities/snack-bar',
        defaultMessage: 'Snack bar',
      });
    case 'amenities/snorkeling':
      return intl.formatMessage({
        id: 'amenities/snorkeling',
        defaultMessage: 'Snorkeling',
      });
    case 'amenities/solarium':
      return intl.formatMessage({
        id: 'amenities/solarium',
        defaultMessage: 'Solarium',
      });
    case 'amenities/soundproof-rooms':
      return intl.formatMessage({
        id: 'amenities/soundproof-rooms',
        defaultMessage: 'Soundproof rooms',
      });
    case 'amenities/spa':
      return intl.formatMessage({
        id: 'amenities/spa',
        defaultMessage: 'Spa',
      });
    case 'amenities/special-diet-meals-on-request':
      return intl.formatMessage({
        id: 'amenities/special-diet-meals-on-request',
        defaultMessage: 'Special diet meals (on request)',
      });
    case 'amenities/stand-up-comedy':
      return intl.formatMessage({
        id: 'amenities/stand-up-comedy',
        defaultMessage: 'Stand-up comedy',
      });
    case 'amenities/steam-room':
      return intl.formatMessage({
        id: 'amenities/steam-room',
        defaultMessage: 'Steam room',
      });
    case 'amenities/sterilizing-equipment':
      return intl.formatMessage({
        id: 'amenities/sterilizing-equipment',
        defaultMessage: 'Sterilizing equipment',
      });
    case 'amenities/strollers':
      return intl.formatMessage({
        id: 'amenities/strollers',
        defaultMessage: 'Strollers',
      });
    case 'amenities/suit-trouser-press':
      return intl.formatMessage({
        id: 'amenities/suit-trouser-press',
        defaultMessage: 'Suit / Trouser press',
      });
    case 'amenities/sun-deck':
      return intl.formatMessage({
        id: 'amenities/sun-deck',
        defaultMessage: 'Sun deck',
      });
    case 'amenities/surfing-lessons':
      return intl.formatMessage({
        id: 'amenities/surfing-lessons',
        defaultMessage: 'Surfing lessons',
      });
    case 'amenities/table-tennis-ping-pong':
      return intl.formatMessage({
        id: 'amenities/table-tennis-ping-pong',
        defaultMessage: 'Table tennis / Ping pong',
      });
    case 'amenities/taxi-service':
      return intl.formatMessage({
        id: 'amenities/taxi-service',
        defaultMessage: 'Taxi service',
      });
    case 'amenities/temperature-check-for-guests-and-staff':
      return intl.formatMessage({
        id: 'amenities/temperature-check-for-guests-and-staff',
        defaultMessage: 'Temperature check for guests and staff',
      });
    case 'amenities/temporary-art-galleries':
      return intl.formatMessage({
        id: 'amenities/temporary-art-galleries',
        defaultMessage: 'Temporary art galleries',
      });
    case 'amenities/tennis-court':
      return intl.formatMessage({
        id: 'amenities/tennis-court',
        defaultMessage: 'Tennis court',
      });
    case 'amenities/terrace':
      return intl.formatMessage({
        id: 'amenities/terrace',
        defaultMessage: 'Terrace',
      });
    case 'amenities/theme-park':
      return intl.formatMessage({
        id: 'amenities/theme-park',
        defaultMessage: 'Theme park',
      });
    case 'amenities/themed-dinners':
      return intl.formatMessage({
        id: 'amenities/themed-dinners',
        defaultMessage: 'Themed dinners',
      });
    case 'amenities/thermometers-for-guests':
      return intl.formatMessage({
        id: 'amenities/thermometers-for-guests',
        defaultMessage: 'Thermometers for guests',
      });
    case 'amenities/ticketing-service':
      return intl.formatMessage({
        id: 'amenities/ticketing-service',
        defaultMessage: 'Ticketing service',
      });
    case 'amenities/toilet-with-grab-rails':
      return intl.formatMessage({
        id: 'amenities/toilet-with-grab-rails',
        defaultMessage: 'Toilet with grab rails',
      });
    case 'amenities/tour-assistance':
      return intl.formatMessage({
        id: 'amenities/tour-assistance',
        defaultMessage: 'Tour Assistance',
      });
    case 'amenities/tours':
      return intl.formatMessage({
        id: 'amenities/tours',
        defaultMessage: 'Tours',
      });
    case 'amenities/towels-changed-upon-request':
      return intl.formatMessage({
        id: 'amenities/towels-changed-upon-request',
        defaultMessage: 'Towels changed upon request',
      });
    case 'amenities/turkish-steam-bath':
      return intl.formatMessage({
        id: 'amenities/turkish-steam-bath',
        defaultMessage: 'Turkish / Steam bath',
      });
    case 'amenities/valet-parking':
      return intl.formatMessage({
        id: 'amenities/valet-parking',
        defaultMessage: 'Valet Parking',
      });
    case 'amenities/vending-machine-drinks':
      return intl.formatMessage({
        id: 'amenities/vending-machine-drinks',
        defaultMessage: 'Vending machine (drinks)',
      });
    case 'amenities/vending-machine-snacks':
      return intl.formatMessage({
        id: 'amenities/vending-machine-snacks',
        defaultMessage: 'Vending machine (snacks)',
      });
    case 'amenities/vending-machines-contents-unspecified':
      return intl.formatMessage({
        id: 'amenities/vending-machines-contents-unspecified',
        defaultMessage: 'Vending machines (contents unspecified)',
      });
    case 'amenities/vip-room-facilities':
      return intl.formatMessage({
        id: 'amenities/vip-room-facilities',
        defaultMessage: 'VIP room facilities',
      });
    case 'amenities/visual-aids-braille':
      return intl.formatMessage({
        id: 'amenities/visual-aids-braille',
        defaultMessage: 'Visual aids: Braille',
      });
    case 'amenities/visual-aids-tactile-signs':
      return intl.formatMessage({
        id: 'amenities/visual-aids-tactile-signs',
        defaultMessage: 'Visual aids: tactile signs',
      });
    case 'amenities/walking-tours':
      return intl.formatMessage({
        id: 'amenities/walking-tours',
        defaultMessage: 'Walking Tours',
      });
    case 'amenities/water-park':
      return intl.formatMessage({
        id: 'amenities/water-park',
        defaultMessage: 'Water park',
      });
    case 'amenities/water-sports-motorized':
      return intl.formatMessage({
        id: 'amenities/water-sports-motorized',
        defaultMessage: 'Water sports (motorized)',
      });
    case 'amenities/water-sports-non-motorized':
      return intl.formatMessage({
        id: 'amenities/water-sports-non-motorized',
        defaultMessage: 'Water sports (non-motorized)',
      });
    case 'amenities/water-sports-equipment-rental':
      return intl.formatMessage({
        id: 'amenities/water-sports-equipment-rental',
        defaultMessage: 'Water sports equipment rental',
      });
    case 'amenities/waterslide':
      return intl.formatMessage({
        id: 'amenities/waterslide',
        defaultMessage: 'Waterslide',
      });
    case 'amenities/windsurfing':
      return intl.formatMessage({
        id: 'amenities/windsurfing',
        defaultMessage: 'Windsurfing',
      });
    case 'amenities/wine-champagne':
      return intl.formatMessage({
        id: 'amenities/wine-champagne',
        defaultMessage: 'Wine / Champagne',
      });
    case 'amenities/yoga':
      return intl.formatMessage({
        id: 'amenities/yoga',
        defaultMessage: 'Yoga',
      });
    case 'amenities/welcome-drink':
      return intl.formatMessage({
        id: 'amenities/welcome-drink',
        defaultMessage: 'Welcome drink',
      });
    default:
      return amenity;
  }
};
